import React from "react";

import Hoc from "../../../util/Hoc";
import CvItem from "../../../components/cvItems/CvItem";
import CvItemDesc from "../../../components/cvItems/CvItemDesc";
import CvItemDetail from "../../../components/cvItems/CvItemDetail";

const cvSectionProDev = (props) => {
  return (
    <Hoc>
      <CvItem date="2020">
        <CvItemDesc descNormal="project management Online tutorial series" />
        {/* <CvItemDetail> Fundamentals </CvItemDetail> */}
        {/* <CvItemDetail> Schedules </CvItemDetail> */}
      </CvItem>

      <CvItem date="2017">
        <CvItemDesc descBold="National Professional Engineering License" />
        <CvItemDetail> Architectural design - License Grade 3</CvItemDetail>
        <CvItemDetail> Construction Supervision - license Grade 3</CvItemDetail>
      </CvItem>

      <CvItem date1="2010" date2="2011">
        <CvItemDesc descNormal="Advance Courses of Interior Design (Iranian Architecture Center)" />
      </CvItem>

      <CvItem date1="2005" date2="2009">
        <CvItemDesc descNormal="Member of Architectural Student Society of the University of Tehran" />
      </CvItem>

      <CvItem date="2007">
        <CvItemDesc descNormal="The National Conference on Structure and Architecture (Tehran, Iran)" />
      </CvItem>
    </Hoc>
  );
};

export default cvSectionProDev;
